import { render, staticRenderFns } from "./Bcafin.vue?vue&type=template&id=6693cc56&scoped=true&"
import script from "./Bcafin.vue?vue&type=script&lang=js&"
export * from "./Bcafin.vue?vue&type=script&lang=js&"
import style0 from "./Bcafin.vue?vue&type=style&index=0&id=6693cc56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6693cc56",
  null
  
)

export default component.exports